import { render, staticRenderFns } from "./ReturnVisitDetails.vue?vue&type=template&id=f37edbca&scoped=true&"
import script from "./ReturnVisitDetails.vue?vue&type=script&lang=js&"
export * from "./ReturnVisitDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReturnVisitDetails.vue?vue&type=style&index=0&id=f37edbca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37edbca",
  null
  
)

export default component.exports